import React, { PureComponent } from 'react'

import { SectionIntro, SectionSelectors } from 'components'
import PHASE from 'utils/constants/phases'
import DATA_SELECTORS from 'data/selectors'
import GameTemplate from 'pages/templates/GameTemplate'
import { translate } from 'react-i18next'
import './Tour.css'

@translate()
export class FirstPage extends PureComponent {
    componentWillMount() {
        const { t } = this.props

        this.selectors = DATA_SELECTORS[PHASE.PRE_SEASON].map(s => ({ ...s, label: t('game.PRE_SEASON.selectorLabel', { name: s.name }) }))
    }

    render() {
        const { className, t } = this.props

        return (
            <GameTemplate className={className}>
                <SectionIntro show text={t('game.PRE_SEASON.intro')} />

                <SectionSelectors id="tour-step-3" selectors={this.selectors} selected={null} onSelect={undefined} />
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Tour/FirstPage.js